import { ChallengeRules } from '../types';
import { fmtDuration } from '../utils/format';

/** "Como funciona": the four steps of the challenge. */
export function StepList({ rules }: { rules: ChallengeRules }) {
  const stayText = rules.minStayMinutes
    ? `Fique pelo menos ${fmtDuration(rules.minStayMinutes)} para ganhar os ${rules.maxPoints} pontos.`
    : `Fique no local até o fim da sua participação para ganhar os ${rules.maxPoints} pontos.`;
  const steps = [
    {
      title: 'Vá ao local',
      text: 'Chegue ao endereço dentro do horário do desafio.',
    },
    {
      title: 'Registre sua entrada',
      text: 'Gere o QR Code e mostre ao seu gestor ao chegar.',
    },
    { title: 'Permaneça no local', text: stayText },
    {
      title: 'Registre sua saída',
      text: 'Gere o QR de saída. Seus pontos entram na hora.',
    },
  ];

  return (
    <section className="pv-card pv-steps" aria-label="Como funciona">
      <h2 className="pv-h3">Como funciona</h2>
      <ol className="pv-steps__list">
        {steps.map((step, i) => (
          <li key={step.title}>
            <span className="pv-steps__num" aria-hidden="true">
              {i + 1}
            </span>
            <div>
              <div className="pv-steps__title">{step.title}</div>
              <div className="pv-muted pv-small">{step.text}</div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
